import React from "react"
import {getPathAndQueryParams, objectLang, setLocalStorageItem} from "../functions"
import Row from "react-bootstrap/Row"
import {Link} from "react-router-dom"
import config from "../config.json"

export class PathLineClass extends React.Component {
    pathStyle

    render() {

        let documents, search, googleDrive = false, style = this.props.pathStyle || {}
        this.props.documents ? documents = this.props.documents : documents = {opening: 'open'}
        this.props.search ? search = this.props.search : search = false
        if (this.props.documents) {
            googleDrive = this.props.documents.googleDrive
        }

        const lang = objectLang().language
        const l = lang.lang
        const paths = documents.path

        let classNameRow = 'd-flex justify-content-center m-0 bg-light pt-1 pb-1 border-start border-end border-bottom'
        if (search) {
            classNameRow = 'd-flex justify-content-center m-0 pt-1 pb-1'
        }

        if (!documents.opening) {
            documents.opening = 'open'
        }
        setLocalStorageItem('documents', documents)

        return (
            <>
                {/* Путь к папке */}
                {<Row id={"row-path"} xs={1} style={style} className={classNameRow}>
                    <div className={'d-flex align-items-center m-auto'} style={{padding: 0}}>
                        <nav aria-label="breadcrumb" id={"nav-breadcrumb"} className={'d-flex align-items-center'}>
                            <ol className="breadcrumb m-auto">
                                {!search && <li className={""}>
                                    <Link to={`/${l}/search`}
                                          className={"link-breadcrumb text-decoration-none text-primary fw-bold rounded-3 ps-3 pe-3 pb-1"}>
                                        <i className="fa-solid fa-magnifying-glass"/>
                                    </Link>
                                </li>}
                                <li key={"0-Path"} className={"first-li breadcrumb-item"}>
                                    <Link to={`/${lang.lang}/`}
                                          className={'link-breadcrumb text-decoration-none text-success fw-bold rounded-3 ps-2 pe-2 pb-1'}>
                                        {`${lang.navbar.toHome}`}
                                    </Link>
                                </li>
                                {paths && paths.map((arr, index) => {
                                        const key = `${index + 1}-Path`
                                        let name = arr[0], path = `/${l}/folder/${documents.opening}/${arr[1]}`
                                        if (name === 'root') {
                                            name = lang.body.myLinksPage.title
                                        }
                                        if (name === 'google-drive') {
                                            name = lang.body.googleDrivePage.title
                                            path = `/${l}/google-drive/open/root`
                                        }
                                        if (name !== lang.body.myLinksPage.titlePublicLinks && documents.path[0][0] === 'root-public') {
                                            path = `/${l}/folder/open-public/${arr[1]}`
                                        }
                                        if (name === 'root-public') {
                                            name = lang.body.myLinksPage.titlePublicLinks
                                            path = `/${l}/folder/open-public/${config.trialRootFolderId}`
                                        }
                                        if (googleDrive || arr[1].length > 24) {
                                            path = `/${l}/google-drive/open/${arr[1]}`
                                        }

                                        return (
                                            <li key={key} className={"breadcrumb-item"}>
                                                <b className={'hand-click link-breadcrumb text-decoration-none text-success fw-bold rounded-3 ps-2 pe-2 pb-1'}
                                                   onClick={() => {
                                                       if (search) {
                                                           window.location.replace(getPathAndQueryParams())
                                                       }
                                                   }}>
                                                    {key === '1-Path' && documents.quota && <Link to={path}
                                                          className={'path-link text-decoration-none text-success fw-bold'}>
                                                        {`${name} `}
                                                        <strike className={'text-decoration-none'} style={{letterSpacing: "-0.06em"}}>
                                                            {`(${(documents.quota.limit / 1073741824).toFixed(1)} GB / ${((documents.quota.limit / 1073741824) - (documents.quota.usage / 1073741824)).toFixed(1)} GB Free)`}
                                                        </strike>
                                                    </Link>}
                                                    {(key !== '1-Path' || !documents.quota) && <Link to={path}
                                                          className={'path-link text-decoration-none text-success fw-bold'}>
                                                        {`${name}`}
                                                    </Link>}
                                                </b>
                                            </li>
                                        )
                                    }
                                )}
                            </ol>
                        </nav>
                    </div>
                </Row>}
            </>

        )
    }

}